import Section from "./Section";
import Button from "./Button";
import ClientItem from "./ClientItem";

import {projects} from '../datas/projects.js';
import {technos} from "../datas/technos.js";
import ButtonNext from "./ButtonNext";



const languages = technos.filter(techno => techno.type === "Language");
const frameworks = technos.filter(techno => techno.type === "Framework");
const others = technos.filter(techno => {
    return techno.type !== "Language" && techno.type !== "Framework";
})

const projectsWithClients = projects.filter(project => project.client);
const clients = projectsWithClients.map(project => {
    return {
        client: project.client,
        client_url: project.client_url
    }
});

function AboutPage(){
    return (
        <div>
            <GetToKnow/>
            <Clients/>
            <Technos/>
        </div>
    );
}



function GetToKnow(){
    return (
        <Section id="AboutGetToKnow">
            <div className="d-section-center">
                <div className="d-section-text">
                    <h1>Get to know me</h1>
                    <h3>Who i am?</h3>
                    <p>My name is Thomas Vaté, master's student at the <a href="https://www.univ-smb.fr">USMB</a>.</p>
                    <p>I'm a software developer, I like to create things and I'm passionate about new technology.</p>
                    <p>Between design, algorithm and data science. I train every day to become better!</p>
                    <h3>Do you want to help me grow?</h3>
                    <a href="/contact">
                        <Button>
                            Contact me
                        </Button>
                    </a>
                </div>
            </div>
            <ButtonNext href="#AboutClients"/>
        </Section>
    );
}

function Clients(){
    return(
        <Section id="AboutClients" negate={1} >
            <div className="d-section-center">
                <div className="d-section-text">
                    <h1>My clients</h1>
                    <h3>Who i worked with?</h3>
                    <p>Here are some of my clients.</p>
                    <p>Let see what I did.</p>
                    <a href="/projects">
                        <Button>
                            Projects
                        </Button>
                    </a>
                </div>
                <div className="d-section-grid">
                    {clients.map((client, index) => {
                        return (
                            <ClientItem client={client} key={index}/>
                        );
                    })}
                </div>
            </div>
            <ButtonNext href="#AboutTechnos"/>
        </Section>
    )
}

function Technos(){
    return (
        <Section id="AboutTechnos">
            <div className="d-section-center">
                <div className="d-section-text">
                    <h1>My technos</h1>
                    <h3>What i use?</h3>
                    <p>Here are some of my technos.</p>
                    <p>Let see what I did.</p>
                    <a href="/projects">
                        <Button>
                            Projects
                        </Button>
                    </a>
                </div>
                <div className="d-section-lists">
                <div className="d-section-list">
                    <h3>Languages</h3>
                    {
                        languages.map((language, index) => {
                            return (
                                <p key={index}>{language.name}</p>
                            );
                        })
                    }
                    </div>
                    <div className="d-section-list">
                    <h3>Frameworks</h3>
                    {
                        frameworks.map((language, index) => {
                            return (
                                <p key={index}>{language.name}</p>
                            );
                        })
                    }
                    </div>
                    <div className="d-section-list">
                    <h3>Others</h3>
                    {
                        others.map((language, index) => {
                            return (
                                <p key={index}>{language.name}</p>
                            );
                        })
                    }
                    </div>
                </div>
            </div>
        </Section>
    );
}

export default AboutPage;